/**
 * Templates index file
 * 
 * This file exports all available templates with their metadata
 */

import generateAvatecTemplate, { AVATEC_DEFAULTS } from './AvatecTemplate';
import generateSmartMarineTemplate, { SMARTMARINE_DEFAULTS } from './SmartMarineTemplate';
import generateAvatecUaeTemplate, { AVATEC_UAE_DEFAULTS } from './AvatecUaeTemplate';

// Template definitions with metadata
export const templates = [
    {
        id: 'avatec',
        name: 'Avatec Marine',
        description: 'Standard Avatec Marine signature with Outlook compatibility',
        generator: generateAvatecTemplate,
        defaults: AVATEC_DEFAULTS
    },
    {
        id: 'smartmarine',
        name: 'Smart Marine',
        description: 'Smart Marine signature with your marine digital solutions branding',
        generator: generateSmartMarineTemplate,
        defaults: SMARTMARINE_DEFAULTS
    },
    {
        id: 'avatec-uae',
        name: 'Avatec Marine UAE',
        description: 'Avatec Marine UAE office signature with prefilled Dubai contact details',
        generator: generateAvatecUaeTemplate,
        defaults: AVATEC_UAE_DEFAULTS
    }
    // Add more templates here as they become available
];

// Default template is the first one in the list
export const defaultTemplate = templates[0];

// Get template by ID
export const getTemplateById = (id) => {
    return templates.find(template => template.id === id) || defaultTemplate;
};